module.exports = __webpack_public_path__ + "static/EditEnv-aa4c88a0e5dc3e99018ce904b6763620.png";